import * as React from 'react';
import { UIHeading2, UIText2, IconPhone16, LinkButton, Responsive } from '@cian/ui-kit';
import * as styles from './BuilderCardMobile.css';
import { IBuilderCardBaseProps } from '../types';
import { Logo } from '../../Logo';
import { LinkArea } from '../../LinkArea';

export interface IBuilderCardMobileProps extends IBuilderCardBaseProps {
  gallery: React.ReactNode;
  onClickCall(event: React.MouseEvent<HTMLAnchorElement>): void;
  label: React.ReactNode;
}

export const BuilderCardMobile: React.FC<IBuilderCardMobileProps> = ({
  gallery,
  logo,
  name,
  phone,
  phoneButton,
  link,
  projectsTypes,
  projectStartPrice,
  materials,
  onClickLink,
  onClickCall,
  label,
}) => {
  return (
    <LinkArea
      href={link}
      target="_blank"
      onClick={onClickLink}
      className={styles['container']}
      dataName="BuilderCardMobile"
    >
      <div className={styles['gallery']}>
        {gallery}
        <div className={styles['logo']}>
          <Logo src={logo} size={60} />
        </div>
      </div>
      <div className={styles['content']}>
        <div className={styles['info']}>
          {label && <div className={styles['label']}>{label}</div>}
          <div className={styles['name']}>
            <UIHeading2>{name}</UIHeading2>
          </div>
          {projectsTypes && (
            <div className={styles['projects']}>
              <UIText2 color="gray60_100">{projectsTypes}</UIText2>
              <UIText2>{projectStartPrice}</UIText2>
            </div>
          )}
          {materials && (
            <div className={styles['materials']}>
              <UIText2 color="gray60_100">Материалы</UIText2>
              <UIText2>{materials}</UIText2>
            </div>
          )}
        </div>
        <Responsive phone>
          <LinkButton
            data-name="BuilderPhoneButton"
            href={`tel:${phone}`}
            onClick={onClickCall}
            size="L"
            fullWidth
            beforeIcon={<IconPhone16 color="white_100" />}
          >
            Позвонить
          </LinkButton>
        </Responsive>
        <Responsive tablet>{phoneButton}</Responsive>
      </div>
    </LinkArea>
  );
};
